const loadJS = (url, callback) => {
  var script = document.createElement('script')

  var fn = callback || function() {}

  script.type = 'text/javascript'

  // IE

  if (script.readyState) {
    script.onreadystatechange = function() {
      // eslint-disable-next-line eqeqeq
      if (script.readyState == 'loaded' || script.readyState ==
          'complete') {
        script.onreadystatechange = null

        fn()
      }
    }
  } else {
    // 其他浏览器

    script.onload = function() {
      fn()
    }
  }

  script.src = url

  document.getElementsByTagName('head')[0].appendChild(script)
}

const wechatShare = (function() {
  var members = {

    wechat: function(title, imgUrl, desc) {
      if (!imgUrl) {
        imgUrl =
            'https://j-job.oss-cn-shanghai.aliyuncs.com/logo.jpg'
      }

      var setWechatShareIcon = function(i) {
        function isWechat() {
          // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
          var ua = window.navigator.userAgent.toLowerCase()
          // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
          // eslint-disable-next-line eqeqeq
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true
          } else {
            return false
          }
        }

        if (!isWechat()) {
          // return;
        }

        var wechatJSSDK = '//res.wx.qq.com/open/js/jweixin-1.2.0.js'

        var callback = function() {
          const callbackKey = [`jsonpcallback${new Date().getTime()}`]
          window[callbackKey] = (n) => {
            var t = n.data

            window.wx.config({
              debug: !1,
              appId: 'wx4cbb30b2fd83dd88',
              timestamp: t.timestamp,
              nonceStr: t.nonceStr,
              signature: t.signature,
              jsApiList: ['onMenuShareTimeline',
                'onMenuShareAppMessage'
              ]
            })
            window.wx.ready(function() {
              // alert(2);
              window.wx.onMenuShareTimeline({
                title: i.title,
                link: document.location.href,
                imgUrl: i.imgUrl,
                success: function() {},
                cancel: function() {}
              })
              window.wx.onMenuShareAppMessage({
                title: i.title,
                desc: i.desc,
                link: document.location.href,
                imgUrl: i.imgUrl,
                type: 'link',
                dataUrl: '',
                success: function() {},
                cancel: function() {}
              })
            })
          }
          loadJS(
            `https://news-d.jin10.com/sign?url=${encodeURIComponent(location.href)}&jsonpCallback=${callbackKey}`,
            () => {

            })

          /* $.ajax({
              url: "https://news-d.jin10.com/sign",
              data: {
                url: location.href
              },

              dataType: "jsonp",
              jsonp: "jsonpCallback"
            }).done(function (n) {
              //alert(n);

              //})
            });*/
        }

        if (typeof wx === 'undefined') {
          loadJS(wechatJSSDK, function() {
            callback()
          })
        } else {
          callback()
        }
      }

      setWechatShareIcon({
        title: title,
        imgUrl: imgUrl,
        desc: desc
      })
    }
  }
  return members
})()

export default wechatShare

